import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';

export class Occupancy extends AbstractReport {

}

AccessorsMutatorsDecorator(
    'start',
    'end',
    'rooms_occupied',
    'rooms_booked',
    'total_revenue',
    'rooms_occupied_compare',
    'rooms_booked_compare',
    'total_revenue_compare',
    'rooms_occupied_pace',
)(Occupancy);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/production/occupancy.model.js